import {useIntl} from 'react-intl';
import {MODAL_TYPE, showModal} from '../../shared/components/modals/generic_modal_conductor';
import {Section} from './Styles';
import {DeprecatedText as Text, FlexRow} from '@forecast-it/design-system';
import CheckBox from '../../../components/new-ui/check_box';
import React from 'react';

const showTrackRevenueConfirmationModal = company => {
	showModal({
		type: MODAL_TYPE.SETTINGS_SETUP_CONFIRM_TOGGLE_REVENUE,
		company: company,
	});
};

export const ToggleRevenue = ({company}) => {
	const {formatMessage} = useIntl();
	const {revenueEnabled} = company;

	return (
		<>
			<Section>
				<Text type={'heading'} variant={'m'}>
					{formatMessage({id: 'settings.setup.revenue_tracking.title'})}
				</Text>
				<FlexRow gap={'l'}>
					<CheckBox isChecked={revenueEnabled} onChange={() => showTrackRevenueConfirmationModal(company)} />
					<Text type={'label'}>{formatMessage({id: 'settings.setup.revenue_tracking.selector_label'})}</Text>
				</FlexRow>
				<Text>{formatMessage({id: 'settings.setup.revenue_tracking.description'})}</Text>
			</Section>
		</>
	);
};
